import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "move-warehouse-modal__container" }
const _hoisted_2 = { class: "move-warehouse-modal__title" }
const _hoisted_3 = { class: "move-warehouse-modal__text" }

import { storeToRefs } from 'pinia';
import { useInventoryStore } from '../pages/useInventoryStore/';
import { i18n } from '@/i18n';
import { contentPropertyOfMoveWarehouse, contentPropertyOfMoveWarehouseWithChoice } from '../constants/contentProperty';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import { InventoryRepository } from '@/coreInfrastructureModule/Repositories/InventoryRepository';
import { computed, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MoveWarehouseModal',
  setup(__props) {

const t = i18n.t;
const inventoryRepository = new InventoryRepository();
const store = useInventoryStore();
const { state } = storeToRefs(store);
const { applyMoveWarehouse } = store;

const checkIds = ref<string[]>([]);

/**
 * 置場移動登録ボタンをDisableにするかどうか
 * 変更のあった取引の差異数量と選択された取引の差異数量の和が0の場合にDisableにする
 */
const isDisableNextButton = computed(() => {
  const checkedIds = checkIds.value;
  const changedBusiness = state.value.moveWarehouseModalState.changedBusiness;
  const otherBusinesses = state.value.moveWarehouseModalState.otherBusinesses.filter((business) =>
    checkedIds.includes(business.businessId)
  );
  if (!changedBusiness || !otherBusinesses) return true;
  const changedAmount = changedBusiness.differenceAmount;
  const otherAmount = otherBusinesses.reduce((acc, business) => acc + business.differenceAmount, 0);
  return changedAmount + otherAmount !== 0;
});

/**
 * チェックボックスの選択時の処理
 * @param item - 選択されたアイテム
 */
const onChecked = (item: string[]) => {
  checkIds.value = item;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _unref(state).moveWarehouseModalState.isOpen,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('置場移動登録'),
    "is-disabled-next-button": isDisableNextButton.value,
    onOnBack: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).moveWarehouseModalState.isOpen = false)),
    onOnNext: _cache[1] || (_cache[1] = ($event: any) => (_unref(applyMoveWarehouse)(_unref(inventoryRepository), checkIds.value)))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('置場移動登録')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('変更のあった取引')), 1),
          _createVNode(NewBaseTableContent, {
            class: "move-warehouse-modal__table",
            "prop-table-content-properties": _unref(contentPropertyOfMoveWarehouse),
            "prop-display-objects": _unref(state).moveWarehouseModalState.changedBusiness ? [_unref(state).moveWarehouseModalState.changedBusiness] : [],
            "prop-loading-status": _unref(state).moveWarehouseModalState.loadingStatus,
            "prop-table-type": 'moveWarehouse'
          }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('差異数量が合うように、置場移動した取引を選択して更新してください。')), 1),
          _createVNode(NewBaseTableContent, {
            class: "move-warehouse-modal__table move-warehouse-modal__table--choice",
            "prop-table-content-properties": _unref(contentPropertyOfMoveWarehouseWithChoice),
            "prop-display-objects": _unref(state).moveWarehouseModalState.otherBusinesses,
            "prop-loading-status": _unref(state).moveWarehouseModalState.loadingStatus,
            "prop-table-type": 'moveWarehouseWithChoice',
            onChecked: onChecked
          }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})